import {
    Bot,
    Briefcase,
    Cloud,
    FlaskConical,
    Home,
    MessageCircle,
    Settings,
    Users,
    Wallet,
    Zap,
} from 'lucide-react'
import type { ElementType } from 'react'

export interface DockItemConfig {
  id: string
  label: string
  icon: ElementType
  path: string
  color: string
  separator?: boolean
  // Window config
  windowTitle?: string
  windowWidth?: number
  windowHeight?: number
  /** true ise pencere icine padding eklenmez */
  noPadding?: boolean
}

export const DOCK_ITEMS: DockItemConfig[] = [
  { id: 'ask',      label: 'Ask RunAI', icon: Zap,           path: '/dashboard/ask',                   color: '#6366f1', windowTitle: 'Ask RunAI',  windowWidth: 720, windowHeight: 580, noPadding: true },
  { id: 'home',     label: 'Home',      icon: Home,          path: '/dashboard',                       color: '#8b5cf6', windowTitle: 'Home',       windowWidth: 900, windowHeight: 600 },
  { id: 'agents',   label: 'Agents',    icon: Users,         path: '/dashboard/agents',                color: '#ec4899', windowTitle: 'Agent Hub',  windowWidth: 860, windowHeight: 580 },
  { id: 'skills',   label: 'Skills',    icon: Zap,           path: '/dashboard/skills',                color: '#10b981', windowTitle: 'Skills',     windowWidth: 900, windowHeight: 600 },
  { id: 'research', label: 'Research',  icon: FlaskConical,  path: '/dashboard/projects/research',     color: '#f59e0b', windowTitle: 'Research',   windowWidth: 880, windowHeight: 580 },
  { id: 'work',     label: 'Work',      icon: Briefcase,     path: '/dashboard/projects/work',         color: '#06b6d4', windowTitle: 'Work',       windowWidth: 860, windowHeight: 560 },
  { id: 'sep1',     label: '',          icon: Home,          path: '',                                 color: '', separator: true },
  { id: 'cloud',    label: 'Cloud',     icon: Cloud,         path: '/dashboard/platforms/cloudflare',  color: '#f6821f', windowTitle: 'Cloudflare', windowWidth: 920, windowHeight: 620 },
  { id: 'social',   label: 'Social',    icon: MessageCircle, path: '/dashboard/social',                color: '#a855f7', windowTitle: 'Social',     windowWidth: 860, windowHeight: 580 },
  { id: 'chat',     label: 'Chat',      icon: Bot,           path: '/dashboard/chat',                  color: '#ef4444', windowTitle: 'Chat',       windowWidth: 700, windowHeight: 560, noPadding: true },
  { id: 'wallet',   label: 'Wallet',    icon: Wallet,        path: '/dashboard/wallet',                color: '#14b8a6', windowTitle: 'Wallet',     windowWidth: 700, windowHeight: 500 },
  { id: 'settings', label: 'Settings',  icon: Settings,      path: '/dashboard/settings',              color: '#8b949e', windowTitle: 'Settings',   windowWidth: 760, windowHeight: 540 },
]
